import React from 'react';
import RichTextEditor from '../../richTextEditor/Editor';

const BlogForm = ({ formData, setFormData }) => {
    const categories = [ "Productivity", "Automation", "Tools", "Ethics", "Education", "Leadership", "Strategy", "Compliance", "Trends", "Health", "Policy", "Governance", "News" ]

    return (
        <div className="space-y-6">
            {/* Basic Information Section */}
            <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">Blog Information</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Blog Title *
                        </label>
                        <input
                            type="text"
                            placeholder="Enter blog title"
                            value={formData.title || ''}
                            onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Author's Name
                        </label>
                        <input
                            type="text"
                            placeholder="e.g., Angela Okon"
                            value={formData.author || ''}
                            onChange={(e) => setFormData({ ...formData, author: e.target.value })}
                            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Author's Job Title/Role
                        </label>
                        <input
                            type="text"
                            placeholder="e.g., Senior Manager "
                            value={formData.authorRole || ''}
                            onChange={(e) => setFormData({ ...formData, authorRole: e.target.value })}
                            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Author's Organisation/Institution
                        </label>
                        <input
                            type="text"
                            placeholder="e.g., Wema Bank "
                            value={formData.authorOrg || ''}
                            onChange={(e) => setFormData({ ...formData, authorOrg: e.target.value })}
                            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                        />
                    </div>
                
                    {/* --- TIPTAP RICH TEXT EDITOR --- */}
                    <div className="md:col-span-2">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Content *
                        </label>
                        <RichTextEditor
                            value={formData.content || ""}
                            onChange={(value) => setFormData({ ...formData, content: value })}
                        />
                    </div>
                    
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Hero Image url *
                        </label>
                        <input
                            type="text"
                            placeholder="Image URL"
                            value={formData.image || ''}
                            onChange={(e) => setFormData({ ...formData, image: e.target.value })}
                            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                        />
                        {/* Show preview if image URL is valid */}
                        {formData.image && (
                            <div className="mt-2">
                            <div className="text-xs text-gray-500 mb-1">Preview:</div>
                            <img
                                src={formData.image}
                                alt="Hero preview"
                                className="max-w-full h-auto max-h-40 rounded object-cover"
                                onError={(e) => (e.target.style.display = 'none')}
                            />
                            </div>
                        )}
                        </div>
            
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Category *
                        </label>
                        
                        {/* Dropdown to add categories */}
                        <select
                            value=""
                            onChange={(e) => {
                            if (e.target.value && !(formData.categories || []).includes(e.target.value)) {
                                const updatedCategories = [...(formData.categories || []), e.target.value];
                                setFormData({ ...formData, categories: updatedCategories });
                            }
                            e.target.value = ""; // Reset dropdown
                            }}
                            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                        >
                            <option value="">Add a category...</option>
                            {categories
                            .filter(cat => !(formData.categories || []).includes(cat))
                            .map(cat => (
                                <option key={cat} value={cat}>{cat}</option>
                            ))}
                        </select>
                        {/* Selected tags */}
                        {formData.categories && formData.categories.length > 0 && (
                            <div className="flex flex-wrap gap-2 mt-2">
                            {formData.categories.map(cat => (
                                <span key={cat} className="inline-flex items-center px-3 py-1 bg-indigo-100 text-indigo-800 text-sm rounded-full">
                                {cat}
                                <button
                                    type="button"
                                    onClick={() => {
                                    const updatedCategories = formData.categories.filter(c => c !== cat);
                                    setFormData({ ...formData, categories: updatedCategories });
                                    }}
                                    className="ml-2 text-indigo-600 hover:text-indigo-800"
                                >
                                    ×
                                </button>
                                </span>
                            ))}
                            </div>
                        )}
                    </div>

                    <div className="flex items-center gap-2">
                        <input
                            type="checkbox"
                            id="featured"
                            checked={formData.featured === true}
                            onChange={(e) => setFormData({ ...formData, featured: e.target.checked })}
                            className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                        />
                        <label htmlFor="featured" className="block text-sm font-medium text-gray-700">
                            Featured *
                        </label>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Publish Date
                        </label>
                        <input
                            type="date"
                            value={formData.date ? new Date(formData.date).toISOString().split('T')[0] : ''}
                            onChange={(e) => setFormData({ ...formData, date: new Date(e.target.value) })}
                            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                        />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default BlogForm;
